'use strict';

class Base {
    constructor() {
        this.oneTrust = new OneTrust();
        this.calculator = new Calculator();
        this.popups = new Popups();

        // On DOM ready
        this.onDomReady();
    }

    // On DOM ready
    onDomReady() {
        const self = this;

        // On DOM ready
        document.addEventListener('DOMContentLoaded', () => {
            if (document.readyState === 'interactive' || document.readyState === 'complete') {
                self.onDomReadyCallback();
            }
        });
    }

    // On DOM ready (callback)
    onDomReadyCallback() {
        const self = this;

        // Init before frameworks
        self.init();

        // Foundation 6 initialization
        jQuery(document).foundation();

        // Init after frameworks
        self.initAfterFrameworks();
    }

    // Init before frameworks
    init() {
        for (var i in this) {
            if (typeof this[i].init === 'function') {
                this[i].init();
            }
        }
    }

    // Init after frameworks
    initAfterFrameworks() {
        for (var i in this) {
            if (typeof this[i].initAfterFrameworks === 'function') {
                this[i].initAfterFrameworks();
            }
        }
    }
}

const TPS = new Base();
